<template>
    <fb-form-body>
        <el-form :model="formData" :rules="rules" ref="form" label-width="100px" class="fb-form">

            <el-form-item label="账户名称" prop="name" :error="formErrorMsg.name">
                <el-input v-model="formData.name"></el-input>
            </el-form-item>


            <el-form-item label="账户编号" prop="number">
                <el-input v-model="formData.number" ></el-input>
            </el-form-item>


            <el-form-item label="账户类型" prop="type">
                <dict-select type-flag="FB_MCH_ACCOUNT_TYPE" v-model="formData.type" ></dict-select>
            </el-form-item>

            <el-form-item label="是否默认" prop="defaultMch">
                <dict-select type-flag="FB_MCH_ACCOUNT_DEFAULT" v-model="formData.defaultMch" ></dict-select>
            </el-form-item>


            <template v-if="['1','3','4'].indexOf(formData.type) !== -1">

                <el-form-item prop="appid" label="应用标识(appid)">
                    <el-input v-model="formData.accountOption.appid" ></el-input>
                </el-form-item>

                <el-form-item prop="mchId" label="商户号(mchId)">
                    <el-input v-model="formData.accountOption.mchId" ></el-input>
                </el-form-item>

                <el-form-item prop="mchKey" label="接口秘钥(mchKey)">
                    <el-input v-model="formData.accountOption.mchKey" ></el-input>
                </el-form-item>

                <el-form-item prop="sandboxKey" label="沙盒秘钥(sandboxKey)">
                    <el-input v-model="formData.accountOption.sandboxKey" ></el-input>
                </el-form-item>

                <el-form-item prop="p12Key" label="证书(p12Key)">
                    <el-input v-model="formData.accountOption.p12Key" ></el-input>
                </el-form-item>

            </template>



            <el-form-item>
                <el-button type="primary" @click="handleSubmit('form')">确定</el-button>
                <el-button @click="handleReset('form')">重置</el-button>
            </el-form-item>
        </el-form>
    </fb-form-body>
</template>

<script>


    import DictSelect from "../../components/DictSelect";
    export default {
        name: "RoleAdd",
        components: {DictSelect},
        data() {
            return {
                api:{
                   add:this.$api.mchAccount.add
                },
                formErrorMsg:{
                    name: '',
                    number: '',
                    type: '',
                    defaultMch: '',
                    status: '',
                },
                formData: {
                    name: '',
                    number: '',
                    type: '',
                    defaultMch: '0',
                    accountOption: {
                        appid:'',
                        mchId:'',
                        mchKey:'',
                        sandboxKey:'',
                        p12Key:'',
                    },
                    status: '',
                },
                rules: {
                    name: [
                        {required: true, message: '账户名称不能为空', trigger: 'blur'},
                    ],
                    number: [
                        {required: true, message: '账户编号不能为空', trigger: 'blur'},
                    ],
                    type: [
                        {required: true, message: '账户类型不能为空', trigger: 'blur'},
                    ],
                    defaultMch: [
                        {required: true, message: '请选择是否默认', trigger: 'blur'},
                    ]

                }
            }
        },
        methods: {
            handleSubmit(form) {

                let vm = this;
                vm.$refs[form].validate((valid) => {
                    if (valid) {

                        let formData = JSON.parse(JSON.stringify(vm.formData));
                        formData.accountOption = JSON.stringify(formData.accountOption);

                        vm.$http.post(vm.api.add,vm.$qs.stringify(formData)).then((resp)=>{

                            if(resp.data.status === 200){
                                vm.$message({
                                    type:'success',
                                    message: resp.data.desc
                                });
                                vm.$router.cgBack();
                            }else if(resp.data.status === 400){



                                resp.data.data.errorFields.forEach(function (a) {

                                    vm.formErrorMsg[a.name] = '';
                                    vm.$nextTick(()=>{
                                        vm.formErrorMsg[a.name] = a.message;
                                    });


                                });

                                if(resp.data.desc){
                                    vm.$message({
                                        type:"error",
                                        message: resp.data.desc
                                    });
                                }


                            }else{
                                vm.$message({
                                    type:"error",
                                    message: resp.data.desc
                                })
                            }

                        });
                        return true;
                    } else {
                        return false;
                    }
                });

            },
            handleReset(form) {
                this.$refs[form].resetFields();
            }
        },
        created() {
            let vm = this;

        }
    }
</script>

<style lang="scss" scoped>

    .fb-form {
        max-width: 500px;
    }

</style>
